import { SidePanelType, useSidePanelActions } from "PFApp/stores/side_panels_store";

import { DetailsPanelData, DetailsPanelType } from "../details_panel.types";

export const useDetailsPanelActions = (type: DetailsPanelType, id: number) =>
  useSidePanelActions<DetailsPanelData>(`${SidePanelType.BookingDetails}_${type}_${id}`);
